/**
 * Angular import.
 */
import { Component, Input, EventEmitter, Output } from '@angular/core';

/**
 * Import interface.
 */
import { EdetailingPharma } from './../model/eDetail.model';

/**
 * Import service.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from 'src/app/common/common-functions/fun-collection.service';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME } from 'src/app/constants/app.constants';

/**
 * Pharma card component.
 */
@Component({
  selector: 'app-edetail-pharma-card',
  templateUrl: './edetail-pharma-card.component.html',
  styleUrls: ['./edetail-pharma-card.component.scss']
})
export class EDetailPharmaCardComponent {

  /**
   * Input pharma data.
   */
  @Input() pharmaData: EdetailingPharma;

  /**
   * Calling pharma card input.
   */
  @Input() callingFrom: string;

  /**
   * Output navigate function.
   */
  @Output() navigateUser = new EventEmitter;

  /**
   * Size of pharma card.
   */
  @Input() size: string;

  /**
   * Required instances.
   */
  constructor(public mls: NewLanguageService, private fcs: FunCollectionService, private analyticSdk: Analytics) { }

  /**
   * When user click on pharma card.
   */
  navigateToDetail(): void {
    if (this.pharmaData?.product_type_id) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.PHARMA, this.pharmaData.product_type_id, this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.PHARMA, null);
    }
    this.navigateUser.emit(this.pharmaData);
  }
  viewDetailButton(): void {
    event.stopPropagation();
    if (this.pharmaData?.product_type_id) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.PHARMA, this.pharmaData.product_type_id, this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.PHARMA_VIEW_DETAIL, null);
    }
    this.navigateUser.emit(this.pharmaData);
  }

}
